// extracted by mini-css-extract-plugin
export var avatar = "Footer-module--avatar--86500";
export var container = "Footer-module--container--0487d";
export var content = "Footer-module--content--2acca";
export var icon = "Footer-module--icon--aedaa";
export var info = "Footer-module--info--72210";
export var name = "Footer-module--name--e6248";
export var position = "Footer-module--position--fc9fd";
export var social = "Footer-module--social--e3cff";
export var splitter = "Footer-module--splitter--f6e27";